
export const linearCustomIconNames = [
    "trafo",
    "plugCharging2",
    "0279-bookmark2"
] as const;

export type LinearCustomIconName = typeof linearCustomIconNames[number];

export const linearIconNames = [
    "0001-home1",
    "0002-home2",
    "0003-home3",
    "0004-home4",
    "0005-home5",
    "0006-home6",
    "0007-bathtub",
    "0008-toothbrush",
    "0009-bed",
    "0010-couch",
    "0011-chair",
    "0012-city",
    "0013-apartment",
    "0014-pencil",
    "0015-pencil2",
    "0016-pen",
    "0017-pencil3",
    "0018-eraser",
    "0019-pencil4",
    "0020-pencil5",
    "0021-feather",
    "0022-feather2",
    "0023-feather3",
    "0024-pen2",
    "0025-pen-add",
    "0026-pen-remove",
    "0027-vector",
    "0028-pen3",
    "0029-blog",
    "0030-brush",
    "0031-brush2",
    "0032-spray",
    "0033-paint-roller",
    "0034-stamp",
    "0035-tape",
    "0036-desk-tape",
    "0037-texture",
    "0038-eye-dropper",
    "0039-palette",
    "0040-color-sampler",
    "0041-bucket",
    "0042-gradient",
    "0043-gradient2",
    "0044-magic-wand",
    "0045-magnet",
    "0046-pencil-ruler",
    "0047-pencil-ruler2",
    "0048-compass",
    "0049-aim",
    "0050-gun",
    "0051-bottle",
    "0052-drop",
    "0053-drop-crossed",
    "0054-drop2",
    "0055-snow",
    "0056-snow2",
    "0057-fire",
    "0058-lighter",
    "0059-knife",
    "0060-dagger",
    "0061-tissue",
    "0062-toilet-paper",
    "0063-poop",
    "0064-umbrella",
    "0065-umbrella2",
    "0066-rain",
    "0067-tornado",
    "0068-wind",
    "0069-fan",
    "0070-contrast",
    "0071-sun-small",
    "0072-sun",
    "0073-sun2",
    "0074-moon",
    "0075-cloud",
    "0076-cloud-upload",
    "0077-cloud-download",
    "0078-cloud-rain",
    "0079-cloud-hailstones",
    "0080-cloud-snow",
    "0081-cloud-windy",
    "0082-sun-wind",
    "0083-cloud-fog",
    "0084-cloud-sun",
    "0085-cloud-lightning",
    "0086-cloud-sync",
    "0087-cloud-lock",
    "0088-cloud-gear",
    "0089-cloud-alert",
    "0090-cloud-check",
    "0091-cloud-cross",
    "0092-cloud-crossed",
    "0093-cloud-database",
    "0094-database",
    "0095-database-add",
    "0096-database-remove",
    "0097-database-lock",
    "0098-database-refresh",
    "0099-database-check",
    "0100-database-history",
    "0101-database-upload",
    "0102-database-download",
    "0103-server",
    "0104-shield",
    "0105-shield-check",
    "0106-shield-alert",
    "0107-shield-cross",
    "0108-lock",
    "0109-rotation-lock",
    "0110-unlock",
    "0111-key",
    "0112-key-hole",
    "0113-toggle-off",
    "0114-toggle-on",
    "0115-cog",
    "0116-cog2",
    "0117-wrench",
    "0118-screwdriver",
    "0119-hammer-wrench",
    "0120-hammer",
    "0121-saw",
    "0122-axe",
    "0123-axe2",
    "0124-shovel",
    "0125-pickaxe",
    "0126-factory",
    "0127-factory2",
    "0128-recycle",
    "0129-trash",
    "0130-trash2",
    "0131-trash3",
    "0132-broom",
    "0133-game",
    "0134-gamepad",
    "0135-joystick",
    "0136-dice",
    "0137-spades",
    "0138-diamonds",
    "0139-clubs",
    "0140-hearts",
    "0141-heart",
    "0142-star",
    "0143-star-half",
    "0144-star-empty",
    "0145-flag",
    "0146-flag2",
    "0147-flag3",
    "0148-mailbox-full",
    "0149-mailbox-empty",
    "0150-at-sign",
    "0151-envelope",
    "0152-envelope-open",
    "0153-paperclip",
    "0154-paper-plane",
    "0155-reply",
    "0156-reply-all",
    "0157-inbox",
    "0158-inbox2",
    "0159-outbox",
    "0160-box",
    "0161-archive",
    "0162-archive2",
    "0163-drawers",
    "0164-drawers2",
    "0165-drawers3",
    "0166-eye",
    "0167-eye-crossed",
    "0168-eye-plus",
    "0169-eye-minus",
    "0170-binoculars",
    "0171-binoculars2",
    "0172-hdd",
    "0173-hdd-down",
    "0174-hdd-up",
    "0175-floppy-disk",
    "0176-disc",
    "0177-tape2",
    "0178-printer",
    "0179-shredder",
    "0180-file-empty",
    "0181-file-add",
    "0182-file-check",
    "0183-file-lock",
    "0184-files",
    "0185-copy",
    "0186-compare",
    "0187-folder",
    "0188-folder-search",
    "0189-folder-plus",
    "0190-folder-minus",
    "0191-folder-download",
    "0192-folder-upload",
    "0193-folder-star",
    "0194-folder-heart",
    "0195-folder-user",
    "0196-folder-shared",
    "0197-folder-music",
    "0198-folder-picture",
    "0199-folder-film",
    "0200-scissors",
    "0201-paste",
    "0202-clipboard-empty",
    "0203-clipboard-pencil",
    "0204-clipboard-text",
    "0205-clipboard-check",
    "0206-clipboard-down",
    "0207-clipboard-left",
    "0208-clipboard-alert",
    "0209-clipboard-user",
    "0210-register",
    "0211-enter",
    "0212-exit",
    "0213-papers",
    "0214-news",
    "0215-reading",
    "0216-typewriter",
    "0217-document",
    "0218-document2",
    "0219-graduation-hat",
    "0220-license",
    "0221-license2",
    "0222-medal-empty",
    "0223-medal-first",
    "0224-medal-second",
    "0225-medal-third",
    "0226-podium",
    "0227-trophy",
    "0228-trophy2",
    "0229-music-note",
    "0230-music-note2",
    "0231-music-note3",
    "0232-playlist",
    "0233-playlist-add",
    "0234-guitar",
    "0235-trumpet",
    "0236-album",
    "0237-shuffle",
    "0238-repeat-one",
    "0239-repeat",
    "0240-headphones",
    "0241-headset",
    "0242-loudspeaker",
    "0243-equalizer",
    "0244-theater",
    "0245-3d-glasses",
    "0246-ticket",
    "0247-presentation",
    "0248-play",
    "0249-film-play",
    "0250-clapboard-play",
    "0251-media",
    "0252-film",
    "0253-film2",
    "0254-surveillance",
    "0255-surveillance2",
    "0256-camera",
    "0257-camera-crossed",
    "0258-camera-play",
    "0259-time-lapse",
    "0260-record",
    "0261-camera2",
    "0262-camera-flip",
    "0263-panorama",
    "0264-time-lapse2",
    "0265-shutter",
    "0266-shutter2",
    "0267-face-detection",
    "0268-flare",
    "0269-convex",
    "0270-concave",
    "0271-picture",
    "0272-picture2",
    "0273-picture3",
    "0274-pictures",
    "0275-book",
    "0276-audio-book",
    "0277-book2",
    "0278-bookmark",
    "0279-bookmark2",
    "0280-label",
    "0281-library",
    "0282-library2",
    "0283-contacts",
    "0284-profile",
    "0285-portrait",
    "0286-portrait2",
    "0287-user",
    "0288-user-plus",
    "0289-user-minus",
    "0290-user-lock",
    "0291-users",
    "0292-users2",
    "0293-users-plus",
    "0294-users-minus",
    "0295-group-work",
    "0296-woman",
    "0297-man",
    "0298-baby",
    "0299-baby2",
    "0300-baby3",
    "0301-baby-bottle",
    "0302-walk",
    "0303-hand-waving",
    "0304-jump",
    "0305-run",
    "0306-woman2",
    "0307-man2",
    "0308-man-woman",
    "0309-height",
    "0310-weight",
    "0311-scale",
    "0312-button",
    "0313-bow-tie",
    "0314-tie",
    "0315-socks",
    "0316-shoe",
    "0317-shoes",
    "0318-hat",
    "0319-pants",
    "0320-shorts",
    "0321-flip-flops",
    "0322-shirt",
    "0323-hanger",
    "0324-laundry",
    "0325-store",
    "0326-haircut",
    "0327-store-24",
    "0328-barcode",
    "0329-barcode2",
    "0330-barcode3",
    "0331-cashier",
    "0332-bag",
    "0333-bag2",
    "0334-cart",
    "0335-cart-empty",
    "0336-cart-full",
    "0337-cart-plus",
    "0338-cart-plus2",
    "0339-cart-add",
    "0340-cart-remove",
    "0341-cart-exchange",
    "0342-tag",
    "0343-tags",
    "0344-receipt",
    "0345-wallet",
    "0346-credit-card",
    "0347-cash-dollar",
    "0348-cash-euro",
    "0349-cash-pound",
    "0350-cash-yen",
    "0351-bag-dollar",
    "0352-bag-euro",
    "0353-bag-pound",
    "0354-bag-yen",
    "0355-coin-dollar",
    "0356-coin-euro",
    "0357-coin-pound",
    "0358-coin-yen",
    "0359-calculator",
    "0360-calculator2",
    "0361-abacus",
    "0362-vault",
    "0363-telephone",
    "0364-phone-lock",
    "0365-phone-wave",
    "0366-phone-pause",
    "0367-phone-outgoing",
    "0368-phone-incoming",
    "0369-phone-in-out",
    "0370-phone-error",
    "0371-phone-sip",
    "0372-phone-plus",
    "0373-phone-minus",
    "0374-voicemail",
    "0375-dial",
    "0376-telephone2",
    "0377-pushpin",
    "0378-pushpin2",
    "0379-map-marker",
    "0380-map-marker-user",
    "0381-map-marker-down",
    "0382-map-marker-check",
    "0383-map-marker-crossed",
    "0384-radar",
    "0385-compass2",
    "0386-map",
    "0387-map2",
    "0388-location",
    "0389-road-sign",
    "0390-calendar-empty",
    "0391-calendar-check",
    "0392-calendar-cross",
    "0393-calendar-31",
    "0394-calendar-full",
    "0395-calendar-insert",
    "0396-calendar-text",
    "0397-calendar-user",
    "0398-mouse",
    "0399-mouse-left",
    "0400-mouse-right",
    "0401-mouse-both",
    "0402-keyboard",
    "0403-keyboard-up",
    "0404-keyboard-down",
    "0405-delete",
    "0406-spell-check",
    "0407-escape",
    "0408-enter2",
    "0409-screen",
    "0410-aspect-ratio",
    "0411-signal",
    "0412-signal-lock",
    "0413-signal-80",
    "0414-signal-60",
    "0415-signal-40",
    "0416-signal-20",
    "0417-signal-0",
    "0418-signal-blocked",
    "0419-sim",
    "0420-flash-memory",
    "0421-usb-drive",
    "0422-phone",
    "0423-smartphone",
    "0424-smartphone-notification",
    "0425-smartphone-vibration",
    "0426-smartphone-embed",
    "0427-smartphone-waves",
    "0428-tablet",
    "0429-tablet2",
    "0430-laptop",
    "0431-laptop-phone",
    "0432-desktop",
    "0433-launch",
    "0434-new-tab",
    "0435-window",
    "0436-cable",
    "0437-cable2",
    "0438-tv",
    "0439-radio",
    "0440-remote-control",
    "0441-power-switch",
    "0442-power",
    "0443-power-crossed",
    "0444-flash-auto",
    "0445-lamp",
    "0446-flashlight",
    "0447-lampshade",
    "0448-cord",
    "0449-outlet",
    "0450-battery-power",
    "0451-battery-empty",
    "0452-battery-alert",
    "0453-battery-error",
    "0454-battery-low1",
    "0455-battery-low2",
    "0456-battery-low3",
    "0457-battery-mid1",
    "0458-battery-mid2",
    "0459-battery-mid3",
    "0460-battery-full",
    "0461-battery-charging",
    "0462-battery-charging2",
    "0463-battery-charging3",
    "0464-battery-charging4",
    "0465-battery-charging5",
    "0466-battery-charging6",
    "0467-battery-charging7",
    "0468-chip",
    "0469-chip-x64",
    "0470-chip-x86",
    "0471-bubble",
    "0472-bubbles",
    "0473-bubble-dots",
    "0474-bubble-alert",
    "0475-bubble-question",
    "0476-bubble-text",
    "0477-bubble-pencil",
    "0478-bubble-picture",
    "0479-bubble-video",
    "0480-bubble-user",
    "0481-bubble-quote",
    "0482-bubble-heart",
    "0483-bubble-emoticon",
    "0484-bubble-attachment",
    "0485-phone-bubble",
    "0486-quote-open",
    "0487-quote-close",
    "0488-dna",
    "0489-heart-pulse",
    "0490-pulse",
    "0491-syringe",
    "0492-pills",
    "0493-first-aid",
    "0494-lifebuoy",
    "0495-bandage",
    "0496-bandages",
    "0497-thermometer",
    "0498-microscope",
    "0499-brain",
    "0500-beaker",
    "0501-skull",
    "0502-bone",
    "0503-construction",
    "0504-construction-cone",
    "0505-pie-chart",
    "0506-pie-chart2",
    "0507-graph",
    "0508-chart-growth",
    "0509-chart-bars",
    "0510-chart-settings",
    "0511-cake",
    "0512-gift",
    "0513-balloon",
    "0514-rank",
    "0515-rank2",
    "0516-rank3",
    "0517-crown",
    "0518-lotus",
    "0519-diamond",
    "0520-diamond2",
    "0521-diamond3",
    "0522-diamond4",
    "0523-linearicons",
    "0524-teacup",
    "0525-teapot",
    "0526-glass",
    "0527-bottle2",
    "0528-glass-cocktail",
    "0529-glass2",
    "0530-dinner",
    "0531-dinner2",
    "0532-chef",
    "0533-scale2",
    "0534-egg",
    "0535-egg2",
    "0536-eggs",
    "0537-platter",
    "0538-steak",
    "0539-hamburger",
    "0540-hotdog",
    "0541-pizza",
    "0542-sausage",
    "0543-chicken",
    "0544-fish",
    "0545-carrot",
    "0546-cheese",
    "0547-bread",
    "0548-ice-cream",
    "0549-ice-cream2",
    "0550-candy",
    "0551-lollipop",
    "0552-coffee-bean",
    "0553-coffee-cup",
    "0554-cherry",
    "0555-grapes",
    "0556-citrus",
    "0557-apple",
    "0558-leaf",
    "0559-landscape",
    "0560-pine-tree",
    "0561-tree",
    "0562-cactus",
    "0563-paw",
    "0564-footprint",
    "0565-speed-slow",
    "0566-speed-medium",
    "0567-speed-fast",
    "0568-rocket",
    "0569-hammer2",
    "0570-balance",
    "0571-briefcase",
    "0572-luggage-weight",
    "0573-dolly",
    "0574-plane",
    "0575-plane-crossed",
    "0576-helicopter",
    "0577-traffic-lights",
    "0578-siren",
    "0579-road",
    "0580-engine",
    "0581-oil-pressure",
    "0582-coolant-temperature",
    "0583-car-battery",
    "0584-gas",
    "0585-gallon",
    "0586-transmission",
    "0587-car",
    "0588-car-wash",
    "0589-car-wash2",
    "0590-bus",
    "0591-bus2",
    "0592-car2",
    "0593-parking",
    "0594-car-lock",
    "0595-taxi",
    "0596-car-siren",
    "0597-car-wash3",
    "0598-car-wash4",
    "0599-ambulance",
    "0600-truck",
    "0601-trailer",
    "0602-scale-truck",
    "0603-train",
    "0604-ship",
    "0605-ship2",
    "0606-anchor",
    "0607-boat",
    "0608-bicycle",
    "0609-bicycle2",
    "0610-dumbbell",
    "0611-bench-press",
    "0612-swim",
    "0613-football",
    "0614-baseball-bat",
    "0615-baseball",
    "0616-tennis",
    "0617-tennis2",
    "0618-ping-pong",
    "0619-hockey",
    "0620-8ball",
    "0621-bowling",
    "0622-bowling-pins",
    "0623-golf",
    "0624-golf2",
    "0625-archery",
    "0626-slingshot",
    "0627-soccer",
    "0628-basketball",
    "0629-cube",
    "0630-3d-rotate",
    "0631-puzzle",
    "0632-glasses",
    "0633-glasses2",
    "0634-accessibility",
    "0635-wheelchair",
    "0636-wall",
    "0637-fence",
    "0638-wall2",
    "0639-icons",
    "0640-resize-handle",
    "0641-icons2",
    "0642-select",
    "0643-select2",
    "0644-site-map",
    "0645-earth",
    "0646-earth-lock",
    "0647-network",
    "0648-network-lock",
    "0649-planet",
    "0650-happy",
    "0651-smile",
    "0652-grin",
    "0653-tongue",
    "0654-sad",
    "0655-wink",
    "0656-dream",
    "0657-shocked",
    "0658-shocked2",
    "0659-tongue2",
    "0660-neutral",
    "0661-happy-grin",
    "0662-cool",
    "0663-mad",
    "0664-grin-evil",
    "0665-evil",
    "0666-wow",
    "0667-annoyed",
    "0668-wondering",
    "0669-confused",
    "0670-zipped",
    "0671-grumpy",
    "0672-mustache",
    "0673-tombstone-hipster",
    "0674-tombstone",
    "0675-ghost",
    "0676-ghost-hipster",
    "0677-halloween",
    "0678-christmas",
    "0679-easter-egg",
    "0680-mustache2",
    "0681-mustache-glasses",
    "0682-pipe",
    "0683-alarm",
    "0684-alarm-add",
    "0685-alarm-snooze",
    "0686-alarm-ringing",
    "0687-bullhorn",
    "0688-hearing",
    "0689-volume-high",
    "0690-volume-medium",
    "0691-volume-low",
    "0692-volume",
    "0693-mute",
    "0694-lan",
    "0695-lan2",
    "0696-wifi",
    "0697-wifi-lock",
    "0698-wifi-blocked",
    "0699-wifi-mid",
    "0700-wifi-low",
    "0701-wifi-low2",
    "0702-wifi-alert",
    "0703-wifi-alert-mid",
    "0704-wifi-alert-low",
    "0705-wifi-alert-low2",
    "0706-stream",
    "0707-stream-check",
    "0708-stream-error",
    "0709-stream-alert",
    "0710-communication",
    "0711-communication-crossed",
    "0712-broadcast",
    "0713-antenna",
    "0714-satellite",
    "0715-satellite2",
    "0716-mic",
    "0717-mic-mute",
    "0718-mic2",
    "0719-spotlights",
    "0720-hourglass",
    "0721-loading",
    "0722-loading2",
    "0723-loading3",
    "0724-refresh",
    "0725-refresh2",
    "0726-undo",
    "0727-redo",
    "0728-jump2",
    "0729-undo2",
    "0730-redo2",
    "0731-sync",
    "0732-repeat-one2",
    "0733-sync-crossed",
    "0734-sync2",
    "0735-repeat-one3",
    "0736-sync-crossed2",
    "0737-return",
    "0738-return2",
    "0739-refund",
    "0740-history",
    "0741-history2",
    "0742-self-timer",
    "0743-clock",
    "0744-clock2",
    "0745-clock3",
    "0746-watch",
    "0747-alarm2",
    "0748-alarm-add2",
    "0749-alarm-remove",
    "0750-alarm-check",
    "0751-alarm-error",
    "0752-timer",
    "0753-timer-crossed",
    "0754-timer2",
    "0755-timer-crossed2",
    "0756-download",
    "0757-upload",
    "0758-download2",
    "0759-upload2",
    "0760-enter-up",
    "0761-enter-down",
    "0762-enter-left",
    "0763-enter-right",
    "0764-exit-up",
    "0765-exit-down",
    "0766-exit-left",
    "0767-exit-right",
    "0768-enter-up2",
    "0769-enter-down2",
    "0770-enter-vertical",
    "0771-enter-left2",
    "0772-enter-right2",
    "0773-enter-horizontal",
    "0774-exit-up2",
    "0775-exit-down2",
    "0776-exit-left2",
    "0777-exit-right2",
    "0778-cli",
    "0779-bug",
    "0780-code",
    "0781-file-code",
    "0782-file-image",
    "0783-file-zip",
    "0784-file-audio",
    "0785-file-video",
    "0786-file-preview",
    "0787-file-charts",
    "0788-file-stats",
    "0789-file-spreadsheet",
    "0790-link",
    "0791-unlink",
    "0792-link2",
    "0793-unlink2",
    "0794-thumbs-up",
    "0795-thumbs-down",
    "0796-thumbs-up2",
    "0797-thumbs-down2",
    "0798-thumbs-up3",
    "0799-thumbs-down3",
    "0800-share",
    "0801-share2",
    "0802-share3",
    "0803-magnifier",
    "0804-file-search",
    "0805-find-replace",
    "0806-zoom-in",
    "0807-zoom-out",
    "0808-loupe",
    "0809-loupe-zoom-in",
    "0810-loupe-zoom-out",
    "0811-cross",
    "0812-menu",
    "0813-list",
    "0814-list2",
    "0815-list3",
    "0816-menu2",
    "0817-list4",
    "0818-menu3",
    "0819-exclamation",
    "0820-question",
    "0821-check",
    "0822-cross2",
    "0823-plus",
    "0824-minus",
    "0825-percent",
    "0826-chevron-up",
    "0827-chevron-down",
    "0828-chevron-left",
    "0829-chevron-right",
    "0830-chevrons-expand-vertical",
    "0831-chevrons-expand-horizontal",
    "0832-chevrons-contract-vertical",
    "0833-chevrons-contract-horizontal",
    "0834-arrow-up",
    "0835-arrow-down",
    "0836-arrow-left",
    "0837-arrow-right",
    "0838-arrow-up-right",
    "0839-arrows-merge",
    "0840-arrows-split",
    "0841-arrow-divert",
    "0842-arrow-return",
    "0843-expand",
    "0844-contract",
    "0845-expand2",
    "0846-contract2",
    "0847-move",
    "0848-tab",
    "0849-arrow-wave",
    "0850-expand3",
    "0851-expand4",
    "0852-contract3",
    "0853-notification",
    "0854-warning",
    "0855-notification-circle",
    "0856-question-circle",
    "0857-menu-circle",
    "0858-checkmark-circle",
    "0859-cross-circle",
    "0860-plus-circle",
    "0861-circle-minus",
    "0862-percent-circle",
    "0863-arrow-up-circle",
    "0864-arrow-down-circle",
    "0865-arrow-left-circle",
    "0866-arrow-right-circle",
    "0867-chevron-up-circle",
    "0868-chevron-down-circle",
    "0869-chevron-left-circle",
    "0870-chevron-right-circle",
    "0871-backward-circle",
    "0872-first-circle",
    "0873-previous-circle",
    "0874-stop-circle",
    "0875-play-circle",
    "0876-pause-circle",
    "0877-next-circle",
    "0878-last-circle",
    "0879-forward-circle",
    "0880-eject-circle",
    "0881-crop",
    "0882-frame-expand",
    "0883-frame-contract",
    "0884-focus",
    "0885-transform",
    "0886-grid",
    "0887-grid-crossed",
    "0888-layers",
    "0889-layers-crossed",
    "0890-toggle",
    "0891-rulers",
    "0892-ruler",
    "0893-funnel",
    "0894-flip-horizontal",
    "0895-flip-vertical",
    "0896-flip-horizontal2",
    "0897-flip-vertical2",
    "0898-angle",
    "0899-angle2",
    "0900-subtract",
    "0901-combine",
    "0902-intersect",
    "0903-exclude",
    "0904-align-center-vertical",
    "0905-align-right",
    "0906-align-bottom",
    "0907-align-left",
    "0908-align-center-horizontal",
    "0909-align-top",
    "0910-square",
    "0911-plus-square",
    "0912-minus-square",
    "0913-percent-square",
    "0914-arrow-up-square",
    "0915-arrow-down-square",
    "0916-arrow-left-square",
    "0917-arrow-right-square",
    "0918-chevron-up-square",
    "0919-chevron-down-square",
    "0920-chevron-left-square",
    "0921-chevron-right-square",
    "0922-check-square",
    "0923-cross-square",
    "0924-menu-square",
    "0925-prohibited",
    "0926-circle",
    "0927-radio-button",
    "0928-ligature",
    "0929-text-format",
    "0930-text-format-remove",
    "0931-text-size",
    "0932-bold",
    "0933-italic",
    "0934-underline",
    "0935-strikethrough",
    "0936-highlight",
    "0937-text-align-left",
    "0938-text-align-center",
    "0939-text-align-right",
    "0940-text-align-justify",
    "0941-line-spacing",
    "0942-indent-increase",
    "0943-indent-decrease",
    "0944-text-wrap",
    "0945-pilcrow",
    "0946-direction-ltr",
    "0947-direction-rtl",
    "0948-page-break",
    "0949-page-break2",
    "0950-sort-alpha-asc",
    "0951-sort-alpha-desc",
    "0952-sort-numeric-asc",
    "0953-sort-numeric-desc",
    "0954-sort-amount-asc",
    "0955-sort-amount-desc",
    "0956-sort-time-asc",
    "0957-sort-time-desc",
    "0958-sigma",
    "0959-pencil-line",
    "0960-hand",
    "0961-pointer-up",
    "0962-pointer-right",
    "0963-pointer-down",
    "0964-pointer-left",
    "0965-finger-tap",
    "0966-fingers-tap",
    "0967-reminder",
    "0968-fingers-crossed",
    "0969-fingers-victory",
    "0970-gesture-zoom",
    "0971-gesture-pinch",
    "0972-fingers-scroll-horizontal",
    "0973-fingers-scroll-vertical",
    "0974-fingers-scroll-left",
    "0975-fingers-scroll-right",
    "0976-hand2",
    "0977-pointer-up2",
    "0978-pointer-right2",
    "0979-pointer-down2",
    "0980-pointer-left2",
    "0981-finger-tap2",
    "0982-fingers-tap2",
    "0983-reminder2",
    "0984-gesture-zoom2",
    "0985-gesture-pinch2",
    "0986-fingers-scroll-horizontal2",
    "0987-fingers-scroll-vertical2",
    "0988-fingers-scroll-left2",
    "0989-fingers-scroll-right2",
    "0990-fingers-scroll-vertical3",
    "0991-border-style",
    "0992-border-all",
    "0993-border-outer",
    "0994-border-inner",
    "0995-border-top",
    "0996-border-horizontal",
    "0997-border-bottom",
    "0998-border-left",
    "0999-border-vertical",
    "1000-border-right",
    "1001-border-none",
    "1002-ellipsis",
] as const;

export type LinearIconName = typeof linearIconNames[number];
